export const statusGroups = [
  {
    id: 'interventional',
    label: 'Study Type: Interventional',
    subLabel: 'Study Recruitment Status:',
    values: [
      'RECSTATUS_RECRUITING',
      'RECSTATUS_I_NOT_YET_REC',
      'RECSTATUS_I_ACTIVE_NOT_REC',
      'RECSTATUS_I_COMPLETED',
      'RECSTATUS_I_TERMINATED_HALT_P',
      'RECSTATUS_I_WITHDRAWN',
      'RECSTATUS_I_SUSPENDED',
    ],
  },
  {
    id: 'observational',
    label: 'Study Type: Observational',
    subLabel: 'Study Status:',
    values: [
      'RECSTATUS_O_ONGOING',
      'RECSTATUS_O_PLANNED',
      'RECSTATUS_O_COMPLETED',
      'RECSTATUS_O_DISCONTINUED',
      'RECSTATUS_O_SUSPENDED',
      'RECSTATUS_O_CANCELLED',
    ],
  },
  {
    id: 'expanded-access',
    label: 'Study Type: Expanded Access',
    subLabel: 'Study Status:',
    values: ['RECSTATUS_EA_AVAILABLE', 'RECSTATUS_EA_NO_LONGER_AVAILABLE'],
  },
];
